// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutUs_main_about_us__OZrFl{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 60px;
    margin-top: 32px;
}

.AboutUs_container__iMjUs{
    width: 100%;
    height: 100%;
    max-width: 1476px;
}
.AboutUs_title__V2znN {
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 40px;
    color: #333;
  }
  
  .AboutUs_aboutUsVideo__mO0VC {
    /* max-width: 900px; */
    margin: 0 auto;
  }
  .AboutUs_video_container__y4djp {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 32px 32px;
    background-color: #fff;
    box-sizing: border-box;
  }
  .AboutUs_video_container__y4djp h2{
    font-size: var(--font-size-3xl);
    font-weight: var(--font-bold);
    text-align: center;
    color: var(--color-accent);
    margin: 0;
  }
  .AboutUs_line__hc5j9{
    width: 60%;
    height: 1px;
    background-color: var(--color-accent);
  }`, "",{"version":3,"sources":["webpack://./src/pages/Home/sections/AboutUs/AboutUs.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,+BAA+B;IAC/B,6BAA6B;IAC7B,kBAAkB;IAClB,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,UAAU;IACV,WAAW;IACX,qCAAqC;EACvC","sourcesContent":[".main_about_us{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 60px;\n    margin-top: 32px;\n}\n\n.container{\n    width: 100%;\n    height: 100%;\n    max-width: 1476px;\n}\n.title {\n    font-size: 36px;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 40px;\n    color: #333;\n  }\n  \n  .aboutUsVideo {\n    /* max-width: 900px; */\n    margin: 0 auto;\n  }\n  .video_container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 15px;\n    padding: 32px 32px;\n    background-color: #fff;\n    box-sizing: border-box;\n  }\n  .video_container h2{\n    font-size: var(--font-size-3xl);\n    font-weight: var(--font-bold);\n    text-align: center;\n    color: var(--color-accent);\n    margin: 0;\n  }\n  .line{\n    width: 60%;\n    height: 1px;\n    background-color: var(--color-accent);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_about_us": `AboutUs_main_about_us__OZrFl`,
	"container": `AboutUs_container__iMjUs`,
	"title": `AboutUs_title__V2znN`,
	"aboutUsVideo": `AboutUs_aboutUsVideo__mO0VC`,
	"video_container": `AboutUs_video_container__y4djp`,
	"line": `AboutUs_line__hc5j9`
};
export default ___CSS_LOADER_EXPORT___;
